export const linearGradientPrimary = "#215383";
